import {
  Component,
  HostListener,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  NgZone,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location, isPlatformBrowser } from '@angular/common';
import { locale as enLang } from '../../i18n/languages/en';
import { locale as esLang } from '../../i18n/languages/es';
import { locale as ptBRLang } from '../../i18n/languages/pt';
import { CommonService } from '../../shared/commonService';
import { TranslationService } from '../../i18n/translation.service';
import { environment } from '../../../environments/environment.dev';
import { filter, Observable, Subscription } from 'rxjs';
import { HomeService } from '../../rwa/home.service';
@Component({
  selector: 'app-landing-layout',
  templateUrl: './default-landing-layout.component.html',
  styleUrls: ['./default-landing-layout.component.scss'],
})
export class DefaultLandingLayoutComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  thumbnail: any;
  public sidebarMinimized = true;
  public navigation: any = [];
  public bussinessName: any;
  selectedQuantity: any;
  theme: any = 'theme-dark';
  showConfig: boolean = false;
  showCanal: boolean = false;
  flagIco: any = 'us';
  centralUri: string = '';
  isScrolled = false;
  toggleNavbar = true;
  showNavbar: boolean = false;
  shopUrl = '';
  ntoUrl = '';
  activeSection: string = 'home';
  public getScreenWidth: any;
  public getScreenHeight: any;
  pathUri: any;
  lastPath: string = '';
  @HostListener('window:scroll', [])
  //private lanSubscription: Subscription = new Subscription;
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
    //this.commonService.yScroller.next(true);
    this.updateActiveSection();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    console.log('resize');
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    if (this.getScreenWidth >= 320 && this.getScreenWidth <= 1024) {
      //this.showNavbar = true;
    } else {
      this.showNavbar = false;
    }
  }

  constructor(
    private router: Router,
    location: Location,
    @Inject(PLATFORM_ID) private platformId: Object,
    private commonService: CommonService,
    private translationService: TranslationService,
    private homeService: HomeService,
    private route: ActivatedRoute
  ) {
    const events = router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ) as Observable<NavigationEnd>;

    events.subscribe((e: NavigationEnd) => {
      let Uri = e.url.split('/');
      (this.pathUri = '/' + Uri[1]), e.url;
    });

    this.translationService.loadTranslations(enLang, esLang, ptBRLang);
    this.commonService.changeLanguage.asObservable().subscribe((value: any) => {
      this.translationService.setLanguage(value);
      this.showConfig = false;
    });
    this.commonService.changeFlag.asObservable().subscribe((value: any) => {
      this.setFlagIcon();
    });
    /*this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    });
    this.changes.observe(<Element>this.element, {
      attributes: true
    });*/

    router.events.subscribe((val) => {
      if (location.path() != '') {
        let Navigation: any = location.path();
        let tmpnavigation = Navigation.split('/');
        this.navigation = tmpnavigation[tmpnavigation.length - 1];
      } else {
      }
    });

    this.route.params.subscribe((params) => {
      console.log(params);
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.isScrolled = window.scrollY > 0;
      this.checkAndRetainLastPathInUrl();
    }
    this.theme = this.commonService.getTheme();
    console.log(
      '===========LANGUAJEHJE=====',
      this.commonService.getLanguage()
    );
    this.translationService.setLanguage(this.commonService.getLanguage());
    this.centralUri =
      environment.ntoUri + '#/login/' + this.commonService.getLanguage();
  }

  ngAfterViewInit(): void {
    //this.flagIco = this.commonService.getFlag();
    setTimeout(() => {
      this.setFlagIcon();
    });
  }

  logout() {}

  toggleTheme(theme: string) {
    //this.commonService.setTheme(theme);
    this.theme = theme;
  }
  switchLanguage(language: string) {}
  showConfigMenu() {
    this.showConfig = true;
  }

  showCanalMenu() {
    this.showCanal = true;
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
    this.showConfig = false;
    this.showCanal = false;
  }

  gotoShop(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.open(this.shopUrl, '_blank');
    }
  }

  gotoNTO(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.open(this.ntoUrl, '_blank');
    }
  }

  onLoginClick(event: Event): void {
    event.preventDefault();
  }

  ngOnDestroy(): void {
    //this.lanSubscription.unsubscribe();
  }

  scrollToSection(section) {
    const element = document.getElementById(section);
    this.activeSection = section;
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    this.showNavbar = false;
    if (this.pathUri == '/terms-conditions') {
      this.router.navigate(['/']);
    }
  }

  updateActiveSection() {
    const sections = [
      'home',
      'prosperity',
      'rwa-types',
      'calculator',
      'faq',
      'stages',
      'sectors',
    ];
    let foundSection = this.activeSection;
    if (this.activeSection == 'stages') {
      this.commonService.animateStage.next(true);
    } else {
      this.commonService.animateStage.next(false);
    }
    for (const section of sections) {
      const element = document.getElementById(section);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
          foundSection = section;
          break;
        }
      }
    }

    if (this.activeSection !== foundSection) {
      this.activeSection = foundSection;
    }
  }

  viewAllCanals() {
    this.homeService.viewCanals.next(true);
  }
  viewAllLanguage() {
    this.homeService.viewLanguage.next(true);
  }

  setFlagIcon() {
    let languaje = this.commonService.getLanguage();
    if (languaje == 'es') {
      this.flagIco = 'es';
    }
    if (languaje == 'en') {
      this.flagIco = 'us';
    }
    if (languaje == 'pt') {
      this.flagIco = 'br';
    }
  }

  checkAndRetainLastPathInUrl() {
    this.lastPath = '';
    const url = window.location.href;
    console.log('🚀 ~ checkAndRetainLastPathInUrl ~ url:', url);

    // Dividir la URL en segmentos utilizando "/"
    const pathSegments = url.split('/');

    // Verificar si hay al menos un segmento de path
    if (pathSegments.length > 0) {
        const potentialLastPath = pathSegments[pathSegments.length - 1];

        // Verificar si el último path no es "rwa" ni "terms-conditions"
        if (potentialLastPath !== 'rwa' && potentialLastPath !== 'terms-conditions') {
            this.lastPath = potentialLastPath;
        }
    }

    console.log(`El último segmento del path es: ${this.lastPath}`);
}

scrollToInit(): void {
  window.scrollTo(0, 0);
}


}
